export default __webpack_public_path__ + "img/wellbore-live.2c00d0d0.png";